import { render, staticRenderFns } from "./UserGetView.vue?vue&type=template&id=bb953294"
import script from "./UserGetView.vue?vue&type=script&lang=js"
export * from "./UserGetView.vue?vue&type=script&lang=js"
import style0 from "./UserGetView.vue?vue&type=style&index=0&id=bb953294&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports